import React,{useState} from "react";
import "./contactcenter.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import optimize_customer_img from "../../assets/images/optimize_customer_img.png";
import bottomleftimg from "../../assets/images/7-2.png"
import bottomrightimg from "../../assets/images/7-1.png"

import designedforyou from "../../assets/images/designedforyourbusiness.svg";
import scalingsolution from "../../assets/images/scalingsolution.svg";
import securitypriority from "../../assets/images/securitypriority.svg";
import dedicatedsupport from "../../assets/images/dedicatedsupport.svg";

import contactcenterhelpdesk from "../../assets/images/contact-center-help-desk.svg"
import targeticon from "../../assets/images/target.svg"
import worldwideicon from "../../assets/images/worldwide-contact-center-icon.svg"
import interactionicon from "../../assets/images/contact-center-interaction-icon.svg"
import Slider from "../../components/Slider/Slider";
import admin_view_icon from '../../assets/images/admin_view_icon.svg'
import crm_integration_icon from '../../assets/images/crm_integration_icon.svg'
import managing_contact_img from '../../assets/images/managing_a_contact.png'

import equip_your_img from '../../assets/images/equip_your_img.png'
import Feedback from "../../components/Feedback/Feedback"
import embedded_voice_calling_img from '../../assets/images/embedded_voice_calling_img.png'

import access_all_your_customer from '../../assets/images/access_all_your_customer.png'
import organizing_campaigns_img from '../../assets/images/organizing_campaigns_img.png'
import Intergrate_email_img from '../../assets/images/Intergrate_email_img.png'
import leverage_whatsapp_img from '../../assets/images/leverage_whatsapp_img.png'
import seamless_voice_calls_img from '../../assets/images/seamless_voice_calls_img.png'

import dufil from "../../assets/clientlogo/13.png"
import tradedepot from "../../assets/clientlogo/12.png"
import wellahealth from "../../assets/clientlogo/wellahealth.png"
import via_SMS from '../../assets/images/via_SMS.png'

export default function ContactCenter(props) {
  const feedback =[
    {
        quote:
            'Kasookoo’s depth of industry knowledge, world-class infrastructure, top-notch support and presence in multiple African countries was what we needed to support our expansion plans. They have helped us stay connected to our customers, resolve issues, have real-time conversations with them about matters that are pertinent to them. Most importantly, we built trust at Trade Depot and transition our Telesales team to a remote distributed team.',
        name: 'Feyishayo Akimoboye',
        role: 'Lead, Telecomms Team, Trade Depot',
        image: tradedepot,
    },
    {
        quote: 'Kasookoo’s has everything it take to deliver on a messaging campaign and that is why we trusted them for our campaign.',
        name: 'Dufil Foods',
        role: '',
        image: dufil,
    },
    {
        quote:
            'Kasookoo helped us to optimize our operations and team strength in responding and communication with our clients. The insights from the Kasookoo platform were especially relevant to help us make strategic marketing and customer service decisions.',
        name: 'Wella Health',
        role: '',
        image: wellahealth,
    },
];
  return (
    <div className="contact-center">
      <Navbar
        extra_heading = "Kasookoo Contact Center"
        heading="A highly efficient Contact Center for Increased Productivity"
        text=" Enable smooth and effortless customer interactions by leveraging a comprehensive cloud-based contact center solution that seamlessly integrates calls, messages, and OTT conversations. Empower your agents and managers with robust integrations that enhance customer engagement to an unprecedented level."
        img={optimize_customer_img}
        first_section = {true}
        setIsFormOpen = {props.setIsFormOpen}
        isFormOpen = {props.isFormOpen}
        contact_center_form ="true"
      ></Navbar>
      <div
        id="num-section-1"
        class="w-100 position-relative block-centered_title "
      >
        <div class="w-100 section-centered_title  py-3 align-items-center text-left text-md-center">
          <div class="container">
            <div class="row ">
              <div class="col-12 mx-auto col-md-8">
                <h6 class="style-h6">
                  TRUSTED BY LEADING ORGANISATIONS WORLDWIDE
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="num-section-2"
        class="w-100 position-relative block-logos pb-3 hide-slick-dots-on-desktop"
      >
        <style></style>

        <div class="w-100 section-logos-slider py-3 py-md-5 bg- ">
          <Slider/>
        </div>
      </div>

      <div
        id="num-section-3"
        class="w-100 position-relative block-centered_title align-items-center text-center pt-5 pb-2"
      >
        <style></style>

        <div class="w-100 section-centered_title align-items-center text-center pt-5 pb-2 py-3 align-items-center text-left text-md-center">
          <div class="container">
            <div class="row ">
              <div class="col-12 mx-auto col-md-8">
                <h2 class="style-h2">
                  An exclusive contact center solution designed specifically for
                  enterprises
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="num-section-4"
        class="w-100 position-relative block-4_main_topics_icon_title_and_summary pt-5"
      >
        <style></style>

        <div class="w-100 section-4_main_topics_icon_title_and_summary py-3">
          <div class="container">
            <div class="row rseh-md justify-content-center fix-style-4">
              <div class="col-12 item-box item-box-4 p-0 p-md-2">
                <div
                  class="w-100 pb-4 ps-3 pe-5 p-md-4 item-4_topics rs_equalHeight"
                  style={{ height: "100%",minHeight:'fit-content' }}
                >
                  <div class="d-block w-100 mb-3">
                    <img
                      src={designedforyou}
                      alt="Group 1000005103"
                    />
                  </div>
                  <div class="d-block w-100 mb-3">
                    <h4 class="style-h4">Designed for your Enterprise</h4>
                  </div>
                  <div class="d-block w-100">
                    <div class="p-small">
                      We empower you to construct the ideal solution that
                      perfectly aligns with your business requirements.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 item-box item-box-4 p-0 p-md-2">
                <div
                  class="w-100 pb-4 ps-3 pe-5 p-md-4 item-4_topics rs_equalHeight"
                  style={{ height: "100%",minHeight:'fit-content' }}
                >
                  <div class="d-block w-100 mb-3">
                    <img
                      src={scalingsolution}
                      alt="Group 1000005101"
                    />
                  </div>
                  <div class="d-block w-100 mb-3">
                    <h4 class="style-h4">
                      Scaling Solutions, Connecting Globally
                    </h4>
                  </div>
                  <div class="d-block w-100">
                    <div class="p-small">
                      Attain swift market penetration, heightened operational
                      effectiveness, and reduced latency across Africa and
                      beyond, harnessing virtual numbers that cover over all african
                      countries, ensuring fullfcfr accessibility.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 item-box item-box-4 p-0 p-md-2">
                <div
                  class="w-100 pb-4 ps-3 pe-5 p-md-4 item-4_topics rs_equalHeight"
                  style={{ height: "100%",minHeight:'fit-content' }}
                >
                  <div class="d-block w-100 mb-3">
                    <img
                      src={dedicatedsupport}
                      alt="Group 1000004943"
                    />
                  </div>
                  <div class="d-block w-100 mb-3">
                    <h4 class="style-h4">Dedicated Customer Support</h4>
                  </div>
                  <div class="d-block w-100">
                    <div class="p-small">
                      Our team provides comprehensive assistance, meaning that
                      whether you require support for your platform or network,
                      you only need to reach out to us.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 item-box item-box-4 p-0 p-md-2">
                <div
                  class="w-100 pb-4 ps-3 pe-5 p-md-4 item-4_topics rs_equalHeight"
                  style={{ height: "100%",minHeight:'fit-content' }}
                >
                  <div class="d-block w-100 mb-3">
                    <img
                      src={securitypriority}
                      alt="Group 1000005102"
                    />
                  </div>
                  <div class="d-block w-100 mb-3">
                    <h4 class="style-h4">Making security a top priority</h4>
                  </div>
                  <div class="d-block w-100">
                    <div class="p-small">
                      When we build our solutions, we take encryption and
                      security very seriously. We use industry-standard
                      encryption methods and security measures to protect our
                      users' data.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 d-md-none bg-archer bg-archer-up">
        <svg
          width="400"
          height="87"
          viewBox="0 0 400 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0C0 0 80.5 40.5 200 40.5C319.5 40.5 400 0 400 0V87H0V0Z"
            fill="#f1f5fe"
          ></path>
        </svg>
      </div>

      <div class="w-100 d-none d-md-block bg-archer bg-archer-up">
        <svg
          width="2500"
          height="178"
          viewBox="0 0 2500 178"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0C0 0 506.625 124 1253.5 124C2000.38 124 2500 0 2500 0V178H0L0 0Z"
            fill="#f1f5fe"
          ></path>
        </svg>
      </div>

      <div
        id="num-section-5"
        class="w-100 position-relative block-topic_center_repeater "
      >
        <style></style>
        <div class="w-100 section-topic_center_repeater">
          <div class="container">
            <div class="row align-items-center style-turquoise">
              <div class="col-12 col-md-6 col-lg-4 side-one">
                <div class="w-100 d-block">
                  <div class="top-title ms-0 me-auto">
                    <img
                      src={admin_view_icon}
                      alt="ADMIN VIEW"
                    />
                    ADMIN VIEW
                  </div>
                </div>
                <div class="w-100 d-block">
                  <div class="title-section-h2">
                    Managing a contact center has never been simpler than this
                  </div>
                </div>

                <div class="w-100 d-block">
                  <div class="entry p-small">
                    <p>
                      Effortlessly handle your agents, customize call flows,
                      access real-time productivity reports, and supervise
                      recorded and live calls through a centralized admin view.
                    </p>
                    <p>
                      <a
                        href=""
                        onClick={(e)=>{e.preventDefault();props.setIsFormOpen(true)}}
                      >
                        Schedule a demo today!
                      </a>
                    </p>
                    <p>&nbsp;</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-8 side-two  ps-md-5">
                <img
                  src={managing_contact_img}
                  alt="Managing a contact image"
                  class="w-100 h-auto mx-auto my-2 img-class"
                />
              </div>
            </div>

            <div class="row small_issues pt-5 py-md-5 style-turquoise">
              <div class="col-12 col-md-4 pb-4 pb-md-1 px-4 px-md-3">
                <div class="title-entry px-md-4 mb-3">
                  Experience real-time visibility into your call center
                  operations.
                </div>
                <div class="text-entry px-md-4">
                  Experience real-time visibility into your call center
                  operations.
                </div>
              </div>
              <div class="col-12 col-md-4 pb-4 pb-md-1 px-4 px-md-3">
                <div class="title-entry px-md-4 mb-3">
                  Integrated Resource Management
                </div>
                <div class="text-entry px-md-4">
                  Streamline your resource management by easily configuring call
                  routing, distribution, and agent status.
                </div>
              </div>
              <div class="col-12 col-md-4 pb-4 pb-md-1 px-4 px-md-3">
                <div class="title-entry px-md-4 mb-3">
                  Effortless Monitoring
                </div>
                <div class="text-entry px-md-4">
                  Enable whispering, eavesdropping, and recording capabilities
                  to enhance agent development and improve customer experience.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="num-section-6"
        class="w-100 position-relative block-top_title pt-5 pb-2"
      >
        <style></style>
        <div class="w-100 section-top_title">
          <div class="container">
            <div class="row align-items-center style-purple">
              <div class="col-12 text-center ">
                <div class="top-title ms-0 mx-md-auto">
                  <img
                    src={contactcenterhelpdesk}
                    alt="AGENT VIEW"
                    class="me-2"
                  />
                  AGENT VIEW
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="num-section-7"
        class="w-100 position-relative block-centered_title text-start text-md-center"
      >
        <style></style>

        <div class="w-100 section-centered_title text-start text-md-center py-3 align-items-center text-left text-md-center">
          <div class="container">
            <div class="row ">
              <div class="col-12 mx-auto col-md-8">
                <h2 class="style-h2">
                  Equip your workforce with the <br /> right communication tools
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="num-section-8"
        class="w-100 position-relative block-centered_title text-start text-md-center"
      >
        <style></style>

        <div class="w-100 section-centered_title text-start text-md-center py-3 align-items-center text-left text-md-center">
          <div class="container">
            <div class="row ">
              <div class="col-12 mx-auto col-md-8">
                <p class="p-small">
                  Engage with customers using various communication channels
                  such as calls, SMS, WhatsApp, and other over-the-top (OTT) and
                  in-app platforms, while seamlessly documenting all
                  interactions through a Contact Centre as a
                  Service (CCaaS) solution.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <div
        id="num-section-9"
        class="w-100 position-relative block-block_text pb-5 pt-4"
      >
        <style></style>
        <div class="container section-block_text">
          <div class="row">
            <div class="col-12">
              <p>&nbsp;</p>
              <p>
                <img
                  decoding="async"
                  loading="lazy"
                  class="aligncenter wp-image-5198 size-full"
                  src={equip_your_img}
                  alt=""
                  
                />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        id="num-section-10"
        class="w-100 position-relative block-centered_title text-start text-md-center pb-3"
      >
        <style></style>

        <div class="w-100 section-centered_title text-start text-md-center pb-3 py-3 align-items-center text-left text-md-center">
          <div class="container">
            <div class="row ">
              <div class="col-12 mx-auto col-md-8">
                <h3 class="style-h3">
                  Enhance customer engagement <br /> through desired
                  communication methods
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="num-section-11"
        class="w-100 position-relative block-items_left_icon pb-5"
      >
        <style></style>
        <div class="w-100 section-items_left_icon">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-12 col-lg-4 d-flex item-box px-sm-5 mb-4 mb-sm-1 ">
                <div class="col-auto ps-sm-2 pe-4 pe-sm-5">
                  <img
                    src={targeticon}
                    alt="Connect with customers on multiple channels."
                    class="middle-box"
                  />
                </div>
                <div class="col pe-1">
                  <p class="p-small mb-0">
                    Engage with customers across a multitude of channels
                  </p>
                </div>
              </div>
              <div class="col-12 col-lg-4 d-flex item-box px-sm-5 mb-4 mb-sm-1 ">
                <div class="col-auto ps-sm-2 pe-4 pe-sm-5">
                  <img
                    src={worldwideicon}
                    alt="Enable agents to work from anywhere. "
                    class="middle-box"
                  />
                </div>
                <div class="col pe-1">
                  <p class="p-small mb-0">
                    Empower workforce with the flexibility to work from any
                    location
                  </p>
                </div>
              </div>
              <div class="col-12 col-lg-4 d-flex item-box px-sm-5 mb-4 mb-sm-1 ">
                <div class="col-auto ps-sm-2 pe-4 pe-sm-5">
                  <img
                    src={interactionicon}
                    alt="Seamless interactions for customers and agents."
                    class="middle-box"
                  />
                </div>
                <div class="col pe-1">
                  <p class="p-small mb-0">
                    Smooth and effortless interactions for both customers and
                    agents
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div id="num-section-12" class="w-100 position-relative block-accordion_list py-5">

        <AccordionComponent/>
         
        </div>



      {/* for
        on click
        change








 */}
      <div class="w-100 d-md-none bg-archer bg-archer-up">
        <svg
          width="400"
          height="87"
          viewBox="0 0 400 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0C0 0 80.5 40.5 200 40.5C319.5 40.5 400 0 400 0V87H0V0Z"
            fill="#f1f5fe"
          ></path>
        </svg>
      </div>

      <div class="w-100 d-none d-md-block bg-archer bg-archer-up">
        <svg
          width="2500"
          height="178"
          viewBox="0 0 2500 178"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0C0 0 506.625 124 1253.5 124C2000.38 124 2500 0 2500 0V178H0L0 0Z"
            fill="#f1f5fe"
          ></path>
        </svg>
      </div>

      <div
        id="num-section-13"
        class="w-100 position-relative block-topic_center_repeater "
      >
        <style></style>
        <div class="w-100 section-topic_center_repeater">
          <div class="container">
            <div class="row align-items-center style-green">
              <div class="col-12 col-md-6 col-lg-4 side-one">
                <div class="w-100 d-block">
                  <div class="top-title ms-0 me-auto">
                    <img
                      src={crm_integration_icon}
                      alt="CRM INTEGRATION"
                    />
                    CRM INTEGRATION
                  </div>
                </div>
                <div class="w-100 d-block">
                  <div class="title-section-h2">
                    Access all your customer info instantly and make calls with
                    ease
                  </div>
                </div>

                <div class="w-100 d-block">
                  <div class="entry p-small">
                    <p>
                      Access all your customer info instantly and make calls
                      with ease. Leverage our seamless CRM integration to empower
                      agents with the same comprehensive call functionality
                      found within the embedded agent view in Salesforce.
                    </p>
                    <p>
                      {/* <a href="#">Discover kosooko for Salesforce.</a> */}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-8 side-two  ps-md-5">
                <img
                  src={access_all_your_customer}
                  alt="Image 42"
                  class="w-100 h-auto mx-auto my-2 img-class"
                />
              </div>
            </div>

            <div class="row small_issues pt-5 py-md-5 style-green">
              <div class="col-12 col-md-4 pb-4 pb-md-1 px-4 px-md-3">
                <div class="title-entry px-md-4 mb-3">
                  Instant <br /> Updates
                </div>
                <div class="text-entry px-md-4">
                  Keep your customer records up-to-date by updating them during
                  calls and syncing them automatically with your CRM.
                </div>
              </div>
              <div class="col-12 col-md-4 pb-4 pb-md-1 px-4 px-md-3">
                <div class="title-entry px-md-4 mb-3">
                  Process <br /> Integration
                </div>
                <div class="text-entry px-md-4">
                  Simple workflow management and calling schedule with instantly
                  joining of your call queues.
                </div>
              </div>
              <div class="col-12 col-md-4 pb-4 pb-md-1 px-4 px-md-3">
                <div class="title-entry px-md-4 mb-3">
                  Integrating Kasookoo <br /> Features in your CRM
                </div>
                <div class="text-entry px-md-4">
                  Stay organized and efficient by completing all of your
                  call-related tasks in one place.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 d-sm-none bg-archer bg-archer-down">
        <svg
          width="400"
          height="87"
          viewBox="0 0 400 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 87C0 87 80.5 46.5 200 46.5C319.5 46.5 400 87 400 87V0H0V87Z"
            fill="#f1f5fe"
          ></path>
        </svg>
      </div>

      <div class="w-100 d-none d-sm-block bg-archer bg-archer-down">
        <svg
          width="2500"
          height="178"
          viewBox="0 0 2500 178"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 178C0 178 506.625 54 1253.5 54C2000.38 54 2500 178 2500 178V0H0L0 178Z"
            fill="#f1f5fe"
          ></path>
        </svg>
      </div>

      <div
        id="num-section-14"
        class="w-100 position-relative block-top_title pt-5"
      >
        <style></style>
        <div class="w-100 section-top_title">
          <div class="container">
            <div class="row align-items-center style-blue">
              <div class="col-12 text-center ">
                <div class="top-title ms-0 mx-md-auto">
                  <img
                    src={contactcenterhelpdesk}
                    alt="CONTACT CENTRE ENRICHMENT"
                    class="me-2"
                  />
                  CONTACT CENTRE ENRICHMENT
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="num-section-15"
        class="w-100 position-relative block-centered_title "
      >
        <style></style>

        <div class="w-100 section-centered_title  py-3 align-items-center text-left text-md-center">
          <div class="container">
            <div class="row ">
              <div class="col-12 mx-auto col-md-8">
                <h2 class="style-h2">Boost your Contact Center </h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="num-section-16"
        class="w-100 position-relative block-centered_title "
      >
        <style></style>

        <div class="w-100 section-centered_title  py-3 align-items-center text-left text-md-center">
          <div class="container">
            <div class="row ">
              <div class="col-12 mx-auto col-md-8">
                <p class="p-small">
                  Enhance customer communications and deliver a seamless
                  customer experience by integrating our all-inclusive suite of
                  communication solutions into your contact center platform.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="num-section-17"
        class="w-100 position-relative block-image_side_and_text_side_repeater "
      >
        <style></style>
        <div class="w-100 section-row_repeater">
          <div class="container">
            <div class="row align-items-center pt-3 pt-md-5 pb-5 ">
              <div class="col-12 col-md-6 text-center text-md-start  ps-lg-5">
                <img
                  src={embedded_voice_calling_img}
                  alt="In app voice"
                  class="mx-auto mb-4 my-md-2"
                />
              </div>
              <div class="col-12 col-md-6 mt-3 mt-md-0  pe-lg-5 order-md-first">
                <div class="w-100 d-block mb-3">
                  <h3 class="style-h3">Embedded Voice Calling </h3>
                </div>
                <div class="w-100 d-block">
                  <div class="p-small">
                    <p>
                      Transform the way customers connect with your contact
                      center by integrating inbound and outbound VoIP calls into
                      your application. With our voice SDK, you can offer an
                      alternative to PSTN calls, allowing customers to call your
                      contact center directly from your app, without the need to
                      switch interfaces.
                    </p>
                  </div>
                </div>
                <div class="w-100 d-block">
                  <ul class="ul-v mb-4">
                    <li class="p-small mb-3">
                       Get rid of from unwanted calls
                    </li>
                    <li class="p-small mb-3">Boost app engagement </li>
                    <li class="p-small mb-3">
                      Ensure security of customer data
                    </li>
                  </ul>
                </div>
                <div class="w-100 d-block">
                  <a href="/#/in-app-voice-calling" class="btn btn-arrow text-start" target="">
                    Start Embedding Calls Into Your App
                  </a>
                </div>
              </div>
            </div>
            <div class="row align-items-center pt-3 pt-md-5 pb-5 ">
              <div class="col-12 col-md-6 text-center text-md-start  pe-lg-5">
                <img
                  src={organizing_campaigns_img}
                  alt="Campaign Manager"
                  class="mx-auto mb-4 my-md-2"
                />
              </div>
              <div class="col-12 col-md-6 mt-3 mt-md-0  ps-lg-5">
                <div class="w-100 d-block mb-3">
                  <h3 class="style-h3">Organizing Campaigns</h3>
                </div>
                <div class="w-100 d-block">
                  <div class="p-small">
                    <p>
                      Our Campaign Manager is a powerful tool that allows you to
                      send and manage SMS campaigns from your contact center.
                    </p>
                    <p>&nbsp;</p>
                  </div>
                </div>
                <div class="w-100 d-block">
                  <ul class="ul-v mb-4">
                    <li class="p-small mb-3">Bulk SMS feature</li>
                    <li class="p-small mb-3">
                      Use tokens to draft personalized messages
                    </li>
                    <li class="p-small mb-3">
                      Uploading contact details at a large scale
                    </li>
                  </ul>
                </div>
                <div class="w-100 d-block">
                  <a href="/#/campaign-manager" class="btn btn-arrow text-start" target="">
                    Launch a New SMS Campaign Today!
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 d-md-none bg-archer bg-archer-up">
        <svg
          width="400"
          height="87"
          viewBox="0 0 400 87"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0C0 0 80.5 40.5 200 40.5C319.5 40.5 400 0 400 0V87H0V0Z"
            fill="#f1f5fe"
          ></path>
        </svg>
      </div>

      <div class="w-100 d-none d-md-block bg-archer bg-archer-up">
        <svg
          width="2500"
          height="178"
          viewBox="0 0 2500 178"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0C0 0 506.625 124 1253.5 124C2000.38 124 2500 0 2500 0V178H0L0 0Z"
            fill="#f1f5fe"
          ></path>
        </svg>
      </div>

      <div
        id="num-section-18"
        class="w-100 position-relative block-recommendations_slider py-4"
      >
        <style></style>
        <div class="w-100 section-recommendations_slider">
        <Feedback feedback={feedback}/>
        </div>
      </div>

      <div
        id="num-section-19"
        class="w-100 position-relative block-cta_strip_2_images "
      >
        <style></style>

        <div class="w-100 section-cta_strip text-white py-0 py-md-3">
          <div class="container pt-5 pt-md-0">
            <div class="row align-items-center py-4 py-md-5">
              <div class="col-12 col-md-3 d-none d-md-flex image-one ">
                <img
                  src={bottomleftimg}
                  alt="Ready for a CCaaS that scales with your growth plans?"
                  class=""
                />
              </div>

              <div class="col-12 col-md-3 image-two  order-md-last ">
                <img
                  src={bottomrightimg}
                  alt="Ready for a CCaaS that scales with your growth plans?"
                  class="d-block mx-auto mx-md-0 mb-4 mb-md-0 w-75 w-md-auto"
                />
              </div>

              <div class="col-12 col-md-6 text-center">
                <div class="d-block w-100 px-md-5">
                  <h2 class="style-h2">
                    Looking for a CCaaS solution that can grow with your
                    business aspirations?
                  </h2>
                </div>
                <div class="d-block w-100 px-md-5">
                  <div class="p-big"></div>
                </div>
                <div class="d-block w-100 px-md-5 mt-3 text-center">
                  <button
                    style={{border:'none'}}
                    class="blact_btn mb-5 mb-md-0 mx-auto"
                    onClick={()=>{props.setIsFormOpen(true)}}
                  >
                    Connect With Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}



export function AccordionComponent() {
 

  const list_accordion_6 =  [
    {
      title: "Seamless Voice Calls Worldwide",
      text: "<p>Facilitate call management and empower various functionalities such as call recording, transfers, and sentiment analysis for enhanced communication.Incorporate our In-App Voice Calling feature into your application to elevate customer experience and foster active customer engagement.</p>",
      image:seamless_voice_calls_img,
      bottom_arrow_link: {
        title: "Seamless Voice Calls Worldwide",
        url: "",
        target: "",
      },
    },
  
    {
      title: "Leverage WhatsApp",
      text: "<p>Enable your agents to seamlessly join customer conversations on the global messaging platform without the need to switch platforms. This saves time, expands your international reach, and provides customers with a familiar channel for engaging with your team.</p>",
      image: leverage_whatsapp_img,
      bottom_arrow_link: {
        title: "Leverage WhatsApp",
        url: "/contact-us",
        target: "",
      },
    },


    {
      title: "Communicate via SMS",
      text: "<p>Cater to customer preferences by offering SMS as a convenient option for delivering time-sensitive updates. Establish a streamlined method to send reminders, surveys, or marketing information to mobile users across 200+ countries via a universal channel.</p>",
      image:via_SMS,
      bottom_arrow_link: {
        title: "Communicate via SMS",
        url: "",
        target: "",
      },
    },




    {
      title: "Integrate email with your contact center",
      text: "<p>Ensure that crucial customer emails receive prompt responses by centralizing email communication for all your agents. By enabling them to send and receive emails from a unified source, you can enhance customer service, improve agent engagement, and expedite issue resolution.</p>",
      image:Intergrate_email_img,
      bottom_arrow_link: {
        title: "Integrate email with your contact center",
        url: "/contact-us/",
        target: "",
      },
    },
    {
      title: "Interact with visitors through webchat",
      text: "<p>Establish direct connections with customers on your website to amplify conversions, generate instant calls to action, and accelerate agent response times. Retain customers on your website while fostering effective collaboration with your team.</p>",
      image:Intergrate_email_img,
      bottom_arrow_link: {
        title: "Interact with visitors through webchat",
        url: "",
        target: "",
      },
    },



    
  ];
  const [activeItem, setActiveItem] = useState(0);

  const showItem = (index) => {
    setActiveItem(index);
  };
  return (
    
      <div className="w-100 section-accordion_list ng-scope">
        <div className="container">
          <div className="row d-md-none">
            <div className="accordion accordion-flush" id="accordionFlush-6">
              {list_accordion_6.map((item, index) => (
                <div className="accordion-item" key={index}>
                  <h2
                    className="accordion-header"
                    id={`flush-heading${index + 1}`}
                  >
                    <button
                      className={`accordion-button ${
                        index === activeItem ? "style-h4" : "collapsed style-h4"
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#flush-collapse${index + 1}`}
                      aria-expanded={index === 0 ? "true" : "false"}
                      aria-controls={`flush-collapse${index + 1}`}
                    >
                      {item.title}
                    </button>
                  </h2>
                  <div
                    id={`flush-collapse${index + 1}`}
                    className={`accordion-collapse collapse ${
                      index === 0 ? "show" : ""
                    }`}
                    aria-labelledby={`flush-heading${index + 1}`}
                    data-bs-parent="#accordionFlush-6"
                  >
                    <div className="accordion-body">
                      <div className="d-block w-100">
                        <img
                          decoding="async"
                          loading="lazy"
                          className="aligncenter size-full size-full mb-3 mb-md-0"
                          src={item.image}
                          alt={item.title}
                        />
                      </div>
                      <div
                        className="d-block w-100 p-small"
                        dangerouslySetInnerHTML={{ __html: item.text }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="row d-none d-md-flex">
            <div className="col-6">
              <h3 className="style-h3 mb-5">Diverse Channels, Countless Advantages</h3>
              {list_accordion_6.map((item, index) => (
                <button
                  className={`list-accordion style-h4 w-100 ng-binding ng-scope ${
                    index === activeItem ? "active" : "text-dark"
                  }`}
                  key={index}
                  onClick={() => showItem(index)}
                  style={{ boxShadow: "none" }}
                >
                  {item.title}
                </button>
              ))}
            </div>
            <div className="col-6">
              <div className="d-block w-100 mb-2">
                <img
                  decoding="async"
                  loading="lazy"
                  className="size-full"
                  src={list_accordion_6[activeItem].image}
                  alt={list_accordion_6[activeItem].title}
                />
              </div>
              <div className="d-block w-100">
                <div className="style-h4 mb-2">
                  {list_accordion_6[activeItem].title}
                </div>
              </div>
              <div
                className="d-block w-100 ng-binding"
                dangerouslySetInnerHTML={{
                  __html: list_accordion_6[activeItem].text,
                }}
              />
              {/* <a
                className="btn btn-arrow text-start ng-binding ng-hide"
                href={list_accordion_6[activeItem].bottom_arrow_link.url}
              >{list_accordion_6[activeItem].bottom_arrow_link.title}</a> */}
            </div>
          </div>
        </div>
      </div>

  );
}